namespace GeniuzPOS.Product {
    export class CsBrandTypeColumns {
        static columnsKey = 'Product.CsBrandType';
    }
}
